import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '',
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center rounded-none font-display uppercase tracking-[0.2em] font-bold transition-all duration-300 focus:outline-none disabled:opacity-50 disabled:pointer-events-none";
  
  const variants = {
    primary: "bg-brand-500 text-black border border-brand-500 hover:bg-white hover:border-white hover:text-black",
    secondary: "bg-transparent border border-white text-white hover:bg-white hover:text-black",
    accent: "bg-white text-black hover:bg-brand-500 hover:text-white",
    outline: "border border-white/20 text-white hover:border-brand-500 hover:text-brand-500",
    ghost: "text-zinc-500 hover:text-white",
  };

  const sizes = {
    sm: "h-10 px-6 text-[10px]",
    md: "h-14 px-10 text-xs",
    lg: "h-16 px-12 text-sm",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
};